import { formatDate } from "@/lib/formatDate";

export const DEFAULT_PAGE_SIZE = 10;

export const getPageCount = (
  totalCount: number,
  pageSize: number = DEFAULT_PAGE_SIZE,
) => {
  return Math.ceil(totalCount / pageSize);
};

export const formatTimestamp = (
  timestamp: number | null | undefined,
  format: string,
  locale: string,
): string => {
  if (!timestamp) return "";
  const date = new Date(timestamp * 1000);
  return formatDate(date, format, { locale: locale as "en" });
};
